import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import cn from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import FormGroupLabel from 'components/FormGroupLabel';
import { Button } from 'components/Button';
import Checkbox from 'components/Form/Checkbox';
import Select from 'components/Form/Select';

import {
  nextAction,
} from 'actions/workflow';
import { parseUrlParams } from 'utils/parseUrlParams';

import style from './style.scss';

const AutoPayElection = ({ history }) => {
  const dispatch = useDispatch();
  const [isSelfSubmitted, setIsSelfSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const params = parseUrlParams(window.location.search);
    if (!params.applicationId) {
      history.push('/dashboard/borrowers-merchant');
    }
  }, []);

  const handleCheckboxChange = (name, value) => {
    if (name === 'isSelfSubmitted') {
      setIsSelfSubmitted(value);
    }
  };

  const handleButtonClick = (e) => {
    e.preventDefault();

    const params = parseUrlParams(window.location.search);
    if (params.applicationId) {
      setIsLoading(true);
      dispatch(nextAction({
        data: {},
        url: `/workflows/application/${params.applicationId}/workflow/dtm/next`,
        success: (response) => {
          const routeUrl = response.state && response.state.url;
          history.push(routeUrl);
        },
        fail: () => {},
      }));
    }
  };

  return (
    <Fragment>
      <Header />
      <section className="container section">
        <div className={cn('grid-container fluid', style.autoPayHeader)} />
        <div className="grid-container fluid borrowers-apply page-autopay">
          <div className="grid-container">
            <div className="grid-x grid-margin-x max-limited">
              <div className={cn('cell small-12 large-8 large-offset-2 form-headline', style.formHeadline)}>
                <h2>Auto-Pay Election</h2>
                <p className="p-large">
                  Enroll in optional Auto-Pay for free and never miss a payment again.<br />
                  <em className={style.pLargeEm}>Plus enroll in optional Auto-Pay and you could earn a $50 American Express Gift Card!*&nbsp; <a href="detail" data-open="Disclaimer" aria-controls="Disclaimer" aria-haspopup="true" tabIndex="0">View Details</a></em>
                </p>
              </div>
              <div className="cell small-12 large-8 large-offset-2">
                <FormGroup className="form-group">
                  <FormGroupLabel value="Bank ACH Information" />
                  <div className="grid-x grid-margin-x">
                    <div className="cell small-12 medium-6">
                      <Input
                        name="bankName"
                        label="Bank Name"
                        placeHolder="Enter Bank name"
                        onChange={() => {}}
                        isRequired
                        isBadgeVisible={false}
                        // hasError={!!errors['channel.attributes.serviceProvider.phone']}
                      />
                    </div>
                    <div className="cell small-12 medium-6">
                      <Input
                        name="nameOnAccount"
                        label="Name on Account"
                        value="Brian L Daley"
                        onChange={() => {}}
                        isBadgeVisible={false}
                        disabled
                        // hasError={!!errors['channel.attributes.serviceProvider.phone']}
                      />
                    </div>
                    <div className="cell small-12 medium-6">
                      <Input
                        name="anaNumber"
                        label="ABA Number"
                        placeHolder="Enter 9 digits ABA Number"
                        onChange={() => {}}
                        isRequired
                        isBadgeVisible={false}
                        // hasError={!!errors['channel.attributes.serviceProvider.phone']}
                      />
                    </div>
                    <div className="cell small-12 medium-6">
                      <Input
                        name="accountNumber"
                        label="Account Number"
                        placeHolder="Enter Account Number"
                        onChange={() => {}}
                        isRequired
                        isBadgeVisible={false}
                        // hasError={!!errors['channel.attributes.serviceProvider.phone']}
                      />
                    </div>
                    <div className="cell small-12 medium-6">
                      <Select
                        data={[
                          { value: 'Checking', title: 'Checking' },
                          { value: 'Savings', title: 'Savings' },
                        ]}
                        name="accountType"
                        label="Account Type"
                        placeHolder="Select..."
                        onChange={() => {}}
                        isRequired
                        // hasError={!!errors['channel.attributes.serviceProvider.phone']}
                      />
                    </div>
                  </div>
                </FormGroup>
                <FormGroup className="form-group">
                  <FormGroupLabel value="Enroll in Auto-Pay" />
                  <div className="grid-x">
                    <div className="cell small-12 padded-bottom padded-bottom-small">
                      <div className="grid-x">
                        <div className="cell small-12 medium-6 padded-bottom-small">
                          <Checkbox
                            label={[
                              <strong>YES</strong>,
                              <Fragment>  &nbsp;–&nbsp;  </Fragment>,
                              'I want to enroll in Auto-Pay and become eligible to receive a $50 gift card!',
                              <Fragment> &nbsp;</Fragment>,
                              <a href="detail" data-open="Disclaimer" aria-controls="Disclaimer" aria-haspopup="true" tabIndex="0">View Details</a>,
                            ]}
                            className={style.checkboxLabel}
                            name="isSelfSubmitted"
                            onChange={handleCheckboxChange.bind(null, 'isSelfSubmitted', true)}
                            isChecked={isSelfSubmitted}
                            value="on"
                            id="isSelfSubmitted"
                            type="radio"
                          />
                          <small className={style.small}>Paying via Auto-Pay is free and assures you pay on time each month.</small>
                        </div>
                        <div className="cell small-12 medium-6 padded-bottom-small">
                          <Checkbox
                            label={[
                              <strong>NO</strong>,
                              <Fragment> &nbsp;-&nbsp; </Fragment>,
                              'I do not want to Enroll in Auto-Pay at this time',
                            ]}
                            className={style.checkboxLabel}
                            name="isSelfSubmittedNo"
                            onChange={handleCheckboxChange.bind(null, 'isSelfSubmitted', false)}
                            isChecked={!isSelfSubmitted}
                            id="isSelfSubmittedNo"
                            value="off"
                            type="radio"
                          />
                        </div>
                      </div>
                    </div>
                    <div className={cn('cell small-12 padded-top', style.formHeadline)}>
                      <p>
                        <em>Please Note:</em> Enrolling in Auto-Pay is optional. The Bank&apos;s credit decision is not dependent on whether you enroll in Auto-Pay. You can change your method of payment at any time in the future.
                      </p>
                    </div>
                    <div className="cell small-12 large-12 padded-bottom padded-bottom-small">
                      <Button
                        className={cn('button large green w-100', style.button, isLoading ? '' : 'arrow')}
                        onClick={handleButtonClick}
                        isLoading={isLoading}
                      >
                        Save & Continue
                      </Button>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

AutoPayElection.propTypes = {
  history: PropTypes.object.isRequired,
};

AutoPayElection.defaultProps = {
};

export default AutoPayElection;



// WEBPACK FOOTER //
// ./src/containers/pages/BorrowerMerchantApply/InternalPages/AutoPayElection/index.js